import {
  V2ResourceResource,
  useV2ListResourcesForAccountQuery,
} from "@generated";

const useListResources = () => {
  const { data, error, isLoading, refetch } = useV2ListResourcesForAccountQuery(
    {
      filter: { active: true },
    }
  );

  let resources: V2ResourceResource[] = [];
  let customError: string | null = null;
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  if (data?.data) {
    try {
      resources = data?.data;
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    resources,
    resourcesError: error || customError,
    resourcesLoading: isLoading,
    pageMeta,
    resourcesRefetch: refetch,
  };
};

export default useListResources;
